const GREEN = '#00FF01';
const ORANGE = '#FF9500';
const RED = '#FC0100';

type GradientStop = { offset: number; color: string };

const THRESHOLD_GREEN_START = 0.8;
const THRESHOLD_GREEN_END = 1.5;
const THRESHOLD_ALL_RED = 2.5;

export const getGradientStops = (absDiff: number): GradientStop[] => {
  if (absDiff < THRESHOLD_GREEN_START) {
    return [
      { offset: 0, color: GREEN },
      { offset: 1, color: GREEN },
    ];
  }
  if (absDiff < THRESHOLD_GREEN_END) {
    const range = THRESHOLD_GREEN_END - THRESHOLD_GREEN_START;
    const t = (absDiff - THRESHOLD_GREEN_START) / range;
    const g2 = 1 - t;
    const b1 = Math.min(g2 + (1 - t) * 0.9, 1);
    return [
      { offset: 0, color: GREEN },
      { offset: g2, color: GREEN },
      { offset: b1, color: ORANGE },
      { offset: 1, color: ORANGE },
    ];
  }
  const range = THRESHOLD_ALL_RED - THRESHOLD_GREEN_END;
  const t = Math.min((absDiff - THRESHOLD_GREEN_END) / range, 1);
  const b2 = 1 - 0.95 * t;
  const r1 = Math.min(b2 + (1 - t) * 0.9 + 0.2, 1);
  return [
    { offset: 0, color: ORANGE },
    { offset: b2, color: ORANGE },
    { offset: r1, color: RED },
    { offset: 1, color: RED },
  ];
};
